<script>
import Confirm from "./confirm"
import { t } from "../../locale"

export default {
  name: "mm-dialog-alert",
  extends: Confirm,

  props: {
    title: {
      type: String,
      default() {
        return t("ui.dialog.title.alert")
      },
    },
    showCancelButton: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
